import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';

import {
    Form, Button, DatePicker, Row, Col, InputNumber, Select, Radio, Input, Tooltip, Icon,
} from 'antd';

import RadioButton from 'antd/lib/radio/radioButton';

import { ADD_PATIENT_DETAILS, MENU_CHANGE, EDIT_EPRESCRIPTION } from '../../ActionTypes/ActionTypes';
import DoneStatusModal from './DoneStatusModal';

const FormItem = Form.Item;
const { Option } = Select;
const RadioGroup = Radio.Group;

class NormalLoginForm extends React.Component {
    state = {
        loading: false,
        fetching: false,
        submitLoading: false,
        data: [],
        partnersList: [],
        partnerLocations: [],
        doctorsList: [],
        user_id: '',
        partner_id: '',
        status: 0,
        doneStatusModal: false,
    };

    componentDidMount = () => {
        this.loadPartners();
    };

    loadPartners = () => {
        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/partners.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                // console.log(response.data);
                this.setState({ partnersList: response.data }, () => {
                    this.setState({ loading: false });
                });
            })
            .catch((error) => {
                alert(`Internet Not working, Please check you connection: ${error.code}`);
            });
    };

    handlePartnerChange = (value) => {
        const { partnersList } = this.state;
        this.setState({
            partner_id: value,
        });

        const newpartners = partnersList.filter(partner => partner.id === Number(value));

        this.setState({
            partnerLocations: newpartners[0].partner_locations,
        });
    };

    onReminderChange = (event) => {
        this.setState({ reminder: event.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const { form, setOrderValuesInStore } = this.props;

        form.validateFields((err, values) => {
            if (!err) {
                values.end_date = '';
                values.start_date = moment(values.start_date).format('YYYY-MM-DD');
                // console.log(values);

                this.setState({ submitLoading: true });

                axios({
                    method: 'post',
                    url: '/users/create_patient',
                    headers: { Authorization: sessionStorage.getItem('jwtToken') },
                    data: {
                        user: {
                            first_name: values.first_name,
                            last_name: values.last_name == null ? '' : values.last_name,
                            is_vip: false,
                        },
                    },
                })
                    .then((response) => {
                        // console.log(response.data);
                        delete values.first_name;
                        delete values.last_name;
                        values.user_id = response.data.id;
                        values.status = 'Incomplete';
                        // console.log(values);
                        axios({
                            method: 'post',
                            url: '/orders.json',
                            headers: { Authorization: sessionStorage.getItem('jwtToken') },
                            data: { order: values },
                        })
                            .then((resp) => {
                                setOrderValuesInStore({
                                    order_id: resp.data.id,
                                    user_id: values.user_id,
                                    start_date: values.start_date,
                                    end_date: values.end_date,
                                    p_prescriptions_url: [],
                                });
                                this.setState({
                                    status: 1,
                                    doneStatusModal: true,
                                    submitLoading: false,
                                });
                                form.resetFields();
                            });
                    });
            }
        });
    };

    goToAllOrders = () => {
        const { history, changeMenu } = this.props;
        this.setState({ doneStatusModal: false });
        history.push('/allOrders');
        changeMenu('/allOrders');
    };

    goToEPrescription = () => {
        const { history, setEPrescriptionMedicine } = this.props;
        setEPrescriptionMedicine([], '');
        this.setState({ doneStatusModal: false });
        history.push('/addMedOrder');
    };

    render() {
        const { form } = this.props;
        const {
            partnersList, partnerLocations,
            partner_id, submitLoading, doneStatusModal,
        } = this.state;

        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 },
            },
        };
        const doubleformItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 10 },
            },
        };
        const thirdformItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5, pull: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12, pull: 6 },
            },
        };

        const terms = ['Short Term', 'Long Term', 'Potential Long Term'];
        const language = ['English', 'Hindi'];

        const optns = partnersList.map(
            partner => (
                <Option key={`${partner.id}`}>
                    {partner.name}
                </Option>
            ),
        );

        const termOptions = terms.map(
            term => (
                <Option key={term} value={term}>
                    {term}
                </Option>
            ),
        );

        const locationOptns = partnerLocations.map(
            location => (
                <Option key={`${location.id}`}>
                    {location.name}
                </Option>
            ),
        );

        const languageOptns = language.map(
            location => (
                <Option key={`${location}`}>
                    {location}
                </Option>
            ),
        );

        return (
            <div style={{ textAlign: 'center', width: '90%', margin: 'auto' }}>
                <Form onSubmit={this.handleSubmit}>

                    <Row type="flex" justify="center">

                        <Col span={12}>
                            <FormItem
                                {...doubleformItemLayout}
                                label="Start Date"
                            >
                                {getFieldDecorator('start_date', {
                                    rules: [{ required: true, message: 'Please select a start date!' }],
                                })(
                                    <DatePicker style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem
                                {...thirdformItemLayout}
                                label="Language"
                            >
                                {getFieldDecorator('order_language', {
                                    rules: [{ required: true, message: 'Label Language?' }],
                                    initialValue: 'English',
                                })(
                                    <Select
                                        showSearch
                                        style={{ width: '83%' }}
                                        placeholder="Order Language?"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {languageOptns}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>

                    </Row>

                    <Row type="flex" justify="center">

                        <Col span={12}>

                            <FormItem
                                {...doubleformItemLayout}
                                label="First Name"
                            >
                                {getFieldDecorator('first_name', {
                                    rules: [{ required: true, message: 'First Name is required!' }],

                                })(
                                    <Input style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={12}>

                            <FormItem
                                {...thirdformItemLayout}
                                label="Last Name"
                            >
                                {getFieldDecorator('last_name', {
                                    rules: [{ required: false, message: 'Name is required!' }],

                                })(
                                    <Input style={{ width: '83%' }} />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row type="flex" justify="center">

                        <Col span={12}>
                            <FormItem
                                {...doubleformItemLayout}
                                label="Partner"
                            >
                                {getFieldDecorator('partner_id', {
                                    rules: [{ required: true, message: 'Name is required!' }],
                                    initialValue: partner_id ? String(partner_id) : 'Select a partner',
                                })(
                                    <Select
                                        style={{ width: '100%' }}
                                        showSearch
                                        onChange={this.handlePartnerChange}
                                        onSelect={this.handlePartnerChange}
                                        placeholder="Select a partner"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {optns}
                                    </Select>,
                                )}

                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem
                                {...thirdformItemLayout}
                                label="Default cycle"
                            >
                                {getFieldDecorator('refill_cycle', {
                                    rules: [{ required: true, message: 'Default cycle length!' }],
                                })(
                                    <InputNumber min={1} style={{ width: '83%' }} />,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem
                                {...doubleformItemLayout}
                                label="Location"
                            >
                                {getFieldDecorator('partner_location_id', {
                                    rules: [{ required: true, message: 'Location is required!' }],
                                })(
                                    <Select
                                        showSearch
                                        placeholder="Select a partner location"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {locationOptns}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem
                                {...thirdformItemLayout}
                                label={(
                                    <span>
                                        <Tooltip title="How long duration of this order is going to be?">
                                        Type
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('order_type', {
                                    rules: [{ required: false, message: 'Type is required!' }],
                                })(
                                    <Select
                                        showSearch
                                        style={{ width: '83%' }}
                                        placeholder="Please select term"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {termOptions}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>

                    </Row>

                    <FormItem
                        {...formItemLayout}
                        label="Need Reminder"
                    >
                        {getFieldDecorator('reminder', {
                            rules: [{ required: true, message: 'Choose one!' }],
                            initialValue: 1,
                        })(
                            <RadioGroup>
                                <RadioButton value={1}>Yes</RadioButton>
                                <RadioButton value={0}>No</RadioButton>
                            </RadioGroup>,
                        )}

                    </FormItem>

                    <br /><br />

                    <Button
                        style={{ marginLeft: '-15%' }}
                        type="primary"
                        loading={submitLoading}
                        htmlType="submit"
                    >
                        Submit
                    </Button>
                    <DoneStatusModal
                        visible={doneStatusModal}
                        onAllOrder={this.goToAllOrders}
                        onEPrescription={this.goToEPrescription}
                    />

                </Form>

            </div>

        );
    }
}

const IncompleteOrderForm = Form.create()(NormalLoginForm);

const mapStateToProps = state => ({
    order_id: state.AppState.order_id,
    medicineList: state.AppState.medicineList,
});
const mapDispatchToProps = dispatch => ({
    setOrderValuesInStore: data => dispatch({ type: ADD_PATIENT_DETAILS, data }),
    changeMenu: key => dispatch({ type: MENU_CHANGE, key }),
    setEPrescriptionMedicine: (list, ep_id) => dispatch({ type: EDIT_EPRESCRIPTION, payload: { list, ep_id } }),
});


export default connect(mapStateToProps, mapDispatchToProps)(IncompleteOrderForm);



// WEBPACK FOOTER //
// ./src/component/AddOrder/AddIncompleteOrderForm.js